<template>
    <!-- About Section -->
    <section class="about-section-two">
        <div class="anim-icons full-width">
            <span class="icon icon-circle-blue wow fadeIn"></span>
            <span class="icon icon-dots wow fadeInleft"></span>
            <span class="icon icon-circle-1 wow zoomIn"></span>
        </div>
        <div class="auto-container">
            <div class="row">
                <!-- Content Column -->
                <div class="content-column col-lg-6 col-md-12 col-sm-12 order-2">
                    <div class="inner-column">
                        <div class="sec-title">
                            <span class="title">QUIENES SOMOS</span>
                            <h2>Bienvenidos al Centro de <br>Convenciones Virtuales BMS</h2>
                            <div class="text">Dolor sit amet consectetur elit sed do eiusmod tempor incd idunt labore et dolore magna aliqua enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip exea commodo consequat.</div>
                        </div>
                        <div class="row">
                            <div class="about-block col-lg-6 col-md-6 col-sm-12">
                                <div class="inner-box">
                                    <h4><span class="icon fa fa-map-marker-alt"></span> Ubicación</h4>
                                    <div class="text">Pearl Hotel, New York, USA</div>
                                </div>
                            </div>
                            <div class="about-block col-lg-6 col-md-6 col-sm-12">
                                <div class="inner-box">
                                    <h4><span class="icon fa fa-clock"></span> when</h4>
                                    <div class="text">January 20, 2020 09:00 AM</div>
                                </div>
                            </div>
                        </div>
                        <div class="btn-box"><a href="contact.html" class="theme-btn btn-style-three"><span class="btn-title">Register Now</span></a></div>
                    </div>
                </div>

                <!-- Image Column -->
                <div class="image-column col-lg-6 col-md-12 col-sm-12">
                    <div class="image-box">
                        <figure class="image wow fadeIn"><img src="@/assets/images/resource/logo-webvideo.png" alt=""></figure>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--End About Section -->
</template>

<script>
    export default {
        
    }
</script>

<style scoped>

</style>